import gql from 'graphql-tag'

export const COMMENT_FIELDS = gql`
  fragment CommentFields on CommentType {
    id
    text
    authorName
    isRemoved
    removedReason
    createdAt
  }
`

export const COMMENTS_QUERY = gql`
  query Comments($jokeId: Int!) {
    comments(jokeId: $jokeId) {
      ...CommentFields
    }
  }
  ${COMMENT_FIELDS}
`

export const ADD_COMMENT_MUTATION = gql`
  mutation AddComment($jokeId: Int!, $text: String!) {
    addComment(jokeId: $jokeId, text: $text) {
      ...CommentFields
    }
  }
  ${COMMENT_FIELDS}
`

export const MY_FAVORITES_QUERY = gql`
  query MyFavorites($count: Int, $offset: Int) {
    myFavorites(count: $count, offset: $offset) {
      id
      text
      authorName
      score
    }
  }
`

export const IS_FAVORITE_QUERY = gql`
  query IsFavorite($jokeId: Int!) {
    isFavorite(jokeId: $jokeId)
  }
`

export const TOGGLE_FAVORITE_MUTATION = gql`
  mutation ToggleFavorite($jokeId: Int!) {
    toggleFavorite(jokeId: $jokeId) {
      isFavorite
      joke {
        id
      }
    }
  }
`
